import { elkReport, setElkScope } from '@/utils/elkReport';

// const DEVDsn = 'https://77b15ed10f6f46d6993b70e3e5bb79db@sentry.popo.netease.com/8';
// const PRODsn = 'https://4ef029a2860b456485c52cb3a811fe97@sentry.popo.netease.com/5';

const able = process.env.NODE_ENV === 'production';
// const able = true;

// export function initSentry() {
//   if (able) {
//     Sentry.init({
//       environment: window.location.hostname === 'meet.popo.netease.com' ? 'production' : 'test',
//       dsn: process.env.NODE_ENV === 'production' ? PRODsn : DEVDsn, // 换成真实的dsn
//       integrations: [new Integrations.BrowserTracing()],

//       // Set tracesSampleRate to 1.0 to capture 100%
//       // of transactions for performance monitoring.
//       // We recommend adjusting this value in production
//       tracesSampleRate: 1.0,
//       release: process.env.REALEASETAG,
//     });
//   }
// }

interface UserData {
  username?: string;
  id?: string;
  meetingId?: string | number;
  yxuid?: string | number;
  uid?: string | number;
  cid?: string | number;
  userAgent?: string;
  userLanguage?: string;
  meetingLanguage?: string;
}

export function setSentryUser(userData: UserData) {
  if (!able) return;
  setElkScope(userData);
}

export function NIMEventLog(TagObj: { [key: string]: string }, err: any) {
  if (!able) return;
  elkReport({ ...TagObj, logTitle: `云信-log_${TagObj.eventType}`, logData: err }).catch((e) =>
    console.error(e)
  );
}
